import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormArray, UntypedFormControl } from '@angular/forms';

import { BehaviorSubject, Subject } from 'rxjs';

import { Undefinable } from '@atmi/core/models';

@Directive()
export abstract class BaseCtrlValueAccessorFormArrayComponent<T> implements ControlValueAccessor, OnInit, OnDestroy {

  private readonly form$ = new BehaviorSubject<Undefinable<UntypedFormArray>>(undefined);
  protected readonly formValue$ = this.form$.asObservable();

  @Input() set form(v: Undefinable<UntypedFormArray>) {
    this.form$.next(v);
  }
  get form() {
    return this.form$.value;
  }

  get value(): T[] {
    return this.form && this.form.value;
  }

  set value(value: T[]) {
    if (this.form) {
      this.form.setValue(value);
      this.form$.next(this.form);

      this.onChange(value);
      this.onTouched();
    }
  }

  get controls() {
    return this.form && this.form.controls as UntypedFormControl[];
  }

  protected readonly unsubscription$ = new Subject();

  constructor() {
  }

  ngOnInit() {
    if (!this.form) {
      throw new Error('Cannot listen to the form without a valid instance');
    }

    this.form.valueChanges.subscribe((value) => {
      this.onChange(value);
      this.onTouched();
    });
  }

  ngOnDestroy() {
    this.unsubscription$.next(null);
    this.unsubscription$.complete();
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: () => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  writeValue(value: T[]) {
    if (!this.form) {
      throw new Error('Cannot write to the form without a valid instance');
    }

    if (value) {
      this.value = value;
    } else {
      this.form.reset();
    }
  }
}
